package info.rezident.app.data.quiz

// Extension function to convert FirestoreQuizQuestion to domain model
fun QuizQuestionModel.toDomainModel(): QuizQuestion {
    return QuizQuestion(
        id = id,
        text = question,
        predefinedPredefinedAnswers = answers.map { (id, text) -> PredefinedAnswer(id, text) }
            .sortedBy { it.id },
        mandatory = mandatory,
        openAnswerPlaceholder = openAnswer,
        search = search ?: false,
        single = single,
        stepId = stepId,
        factor = factor,
        fiveScale = fiveScale,
        scaleExplanation = scaleExplanation
    )
}

// Extension function to convert FirestoreQuizStep to domain model
fun QuizStepModel.toDomainModel(): QuizStep {
    return QuizStep(
        id = id,
        title = title,
        subtitle = subtitle
    )
}